/**
 * The row indexes a windowed list mounts: `indexes` (the rows in view, from the virtualizer), plus the
 * focused row when it is outside them, so scrolling never unmounts the row that has keyboard focus.
 * Sorted and unique, as the virtualizer expects.
 */
export function withFocused(indexes: readonly number[], focused: number | null): number[] {
  if (focused === null || indexes.includes(focused)) return [...indexes];
  return [...indexes, focused].sort((a, b) => a - b);
}
